<template>
  <Head :title="__('vip-order-for-who.meta.title')">
    <meta
      name="description"
      :content="__('vip-order-for-who.meta.description')"
    >
    <link
      rel="canonical"
      :href="localeRoute('frontend.vips.order.for-who', [vip, shoutOut])"
    >
    <meta
      property="og:image"
      content="/frontend/assets/favicon/og-image.jpg"
    >
  </Head>

  <Order
    :vip="vip"
    :current-step="1"
  >
    <template #step>
      <form @submit.prevent="submit">
        <div class="w-full grid grid-cols-1 gap-4 md:gap-6 mt-4 lg:mt-8 lg:grid-cols-2">
          <div class="w-full flex flex-wrap content-between">
            <div class="w-full flex-wrap whitespace-normal overflow-auto">
              <button
                v-for="(occasion, i) in occasions"
                :key="`occasion-${occasion.slug}`"
                type="button"
                class="inline py-2 rounded-xl mb-2"
                :class="occasionClasses(i)"
                @click="form.occasion_slug = occasion.slug"
              >
                {{ occasion.short_name }}
                <img
                  v-show="form.occasion_slug === occasion.slug"
                  src="/frontend/assets/check-white.svg"
                  class="inline-block ml-1"
                >
              </button>
            </div>

            <div class="mt-3 w-full">
              <InputField
                v-model="form.for"
                :form="form"
                classes="border"
                name="for"
                type="text"
                :label="__('vip-order-for-who.form.for.text')"
                :placeholder="__('vip-order-for-who.form.for.placeholder')"
                maxlength="255"
              />
            </div>
          </div>

          <div class="w-full">
            <TextareaField
              v-model="form.message"
              :form="form"
              classes="border"
              :label="__('vip-order-for-who.form.message.text', {vip: vip.first_name})"
              :max-length="300"
              :placeholder="selectedOccasion.placeholder"
              name="message"
              rows="8"
            />
          </div>
        </div>

        <div class="mt-12 w-full lg:text-center">
          <button
            type="submit"
            class="button-green shadow-button-black w-full block lg:w-auto lg:inline-block lg:px-16"
          >
            {{ __('vip-order-for-who.continue') }}
            <img
              src="/frontend/assets/white-arrow.svg"
              class="inline ml-2"
            >
          </button>

          <Link
            :href="localeRoute('frontend.vips.show', [vip])"
            class="text-gray-500 font-bold mt-4 block text-center"
          >
            {{ __('vip-order-for-who.back') }}
          </Link>
        </div>
      </form>
    </template>
  </Order>
</template>

<script>
import {useForm} from '@inertiajs/vue3';
import Clean from '../../../Layout/Clean.vue';
import Order from './Order.vue';
import InputField from '../../../Components/Form/InputField.vue';
import TextareaField from '../../../Components/Form/TextareaField.vue';

export default {
  components: {
    Order,
    InputField,
    TextareaField,
  },

  layout: Clean,

  props: {
    vip: {
      type: Object,
      required: true,
    },

    shoutOut: {
      type: Object,
      required: true,
    },

    occasions: {
      type: Array,
      required: true,
    },
  },

  setup (props) {
    const form = useForm({
      occasion_slug: props.shoutOut.occasion?.slug || props.occasions[0].slug,
      for: props.shoutOut.for || '',
      message: props.shoutOut.message || '',
    });

    return {form};
  },

  computed: {
    selectedOccasion() {
      return this.occasions.find((occasion) => occasion.slug === this.form.occasion_slug);
    },
  },

  methods: {
    occasionClasses(index) {
      const classes = [];
      classes.push('ml-2 pl-6 pr-6 lg:pr-4');

      if (this.form.occasion_slug === this.occasions[index].slug) {
        classes.push('border border-red bg-red text-white');
      } else {
        classes.push('border-2 border-black text-black');
      }

      return classes;
    },

    submit() {
      this.form.post(this.localeRoute('frontend.vips.order.for-who.store', [this.vip, this.shoutOut]));
    },
  },
};
</script>
